export default "__VITE_ASSET__B7ZK8JoG__"